import React from "react";

import { DocumentsProps } from "./interfaces";
import {
  DocumentListContainer,
  DocumentList,
  DocumentListTitle,
  DocumentListTitleNote,
  DocumentListItem,
} from "./styled";

const NoActionDocuments = ({
  companyName = "",
  documentNames = [],
}: DocumentsProps) => (
  <DocumentListContainer>
    <DocumentList>
      <DocumentListTitle>
        No action taken
        <DocumentListTitleNote>
          {` (already assigned to ${companyName}):`}
        </DocumentListTitleNote>
      </DocumentListTitle>

      {documentNames.map((documentName) => (
        <DocumentListItem key={documentName}>{documentName}</DocumentListItem>
      ))}
    </DocumentList>
  </DocumentListContainer>
);

export default NoActionDocuments;
